import { useEffect, useState } from "react";

/**
 * A clock that ticks slowly.
 *
 * Everything time-shaped here is read in minutes, so a per-second tick would
 * buy nothing and re-render a table of thirty rows sixty times a minute --
 * movement in the corner of the eye of somebody trying to read a row.
 */
export function useNow(intervalMs = 15_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);
  return now;
}
